import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { LoginError } from "./LoginError";
import "./style/ModalConfirmCode.css";
import { pageLoginText } from "../../lib/constants";

export const ModalConfirmCode = ({ 
  show, 
  onHide, 
  email, 
  onConfirm, 
  onResendCode,
  isLoading = false,
  isResending = false,
  error = null 
}) => {
  const [code, setCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(code);
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) {
      setCode(value);
    }
  };

  const handleResendCode = () => {
    setCode("");
    onResendCode();
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      backdrop="static"
      className="modal-confirm-code"
    >
      <Modal.Header className="border-bottom-0 confirm-code-title" closeButton>
      Confirma tu correo electrónico
      </Modal.Header>
        <Modal.Body>
          <div className="confirm-code-content">
            <p className="confirm-code-description">
              {pageLoginText.confirm_code_description} <strong>{email}</strong>.
            </p>

            {error && (
                <LoginError 
                error={error} 
                title="Código no válido" 
              />
            )}

            <Form onSubmit={handleSubmit} className="confirm-code-form">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="_ _ _ _ _ _"
                  value={code} 
                  onChange={handleCodeChange}
                  className={error ? "is-invalid" : ""}
                  maxLength={6}
                  autoFocus/>
                {error && (
                  <div className="text-danger mt-2">
                    {"Código no válido"}
                  </div>
                )}
              </Form.Group>

              <div className="confirm-code-buttons">
                <Button
                  type="submit"
                  variant="primary"
                  disabled={isLoading || !code || code.length < 4}
                  className="w-100"
                >
                  {isLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Confirmando...
                    </>
                  ) : (
                    pageLoginText.confirm_code
                  )}
                </Button>

                <Button
                  type="button"
                  className="btn-resend-code "
                  onClick={handleResendCode}
                  disabled={isResending || isLoading}
                >
                  {isResending ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Reenviando...
                    </>
                  ) : (
                    pageLoginText.resend_code
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
    </Modal>
  );
};